import { defineGameCard, heatsUp } from '../authoring/index.js';
export const SiegeResonatorCard = defineGameCard({
    id: 'siege_resonator',
    gameplay: {
        type: 'UNIT', cost: 5,
        baseStats: { attack: 7, health: 5 },
    },
    presentation: {
        name: 'Осадный резонатор',
        description: 'Греется.',
        glyph: {
            colors: ['#E9DDC7', '#10213A', '#423E40', '#7D776D', '#AC4F23'],
            rows: [
                '.11.1.........1.111.',
                '1111....2222...11111',
                '.1111..234442.111111',
                '1111.5.3233325.1111.',
                '1111.5.3222225.11111',
                '.111555325522552111.',
                '1..1325223322523122.',
                '.2233333444443234432',
                '.2233323333333233332',
                '.222232325552222222.',
                '..2223232555222222..',
                '.222222325552222332.',
                '.233322222222222332.',
                '.2333..233332.22332.',
                '.2333.2322333332332.',
                '.233322322322332332.',
                '.22332442..22442322.',
                '..2222332..2233223..',
                '.....2222..2222.....',
                '....22222..223332...',
            ],
        },
    },
    role: 'playable',
    abilities: [heatsUp()],
    ui: { mechanics: ['heats_up', 'heat'] },
});
//# sourceMappingURL=siege-resonator.js.map